import { Trans } from '@lingui/react/macro';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { LogOut } from 'lucide-react';
import { useEffect } from 'react';

import { useAuth } from '@/app/auth';
import { Spinner } from '@/shared/ui/spinner';

export const Route = createFileRoute('/login/logout')({
  component: LogoutScreen,
});

/** Teto do "Saindo!": a lib travada não segura a pessoa aqui; o estado e o cache já saíram na hora. */
const LOGOUT_TIMEOUT_MS = 3_000;

/** "Saindo!": logout local do Cognito e volta ao login, sempre (falhou ou demorou, vai do mesmo jeito). */
function LogoutScreen() {
  const { session } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      void navigate({ to: '/login', replace: true });
    };
    const timer = setTimeout(finish, LOGOUT_TIMEOUT_MS);
    // Falha síncrona ou assíncrona do logout não segura a pessoa aqui.
    void Promise.resolve()
      .then(() => session.signOut())
      .catch(() => undefined)
      .finally(finish);
    return () => clearTimeout(timer);
  }, [session, navigate]);

  return (
    <div className="flex flex-col items-center gap-5 text-center" role="status">
      <span aria-hidden className="relative inline-flex size-14 items-center justify-center rounded-2xl bg-accent-wash text-accent-text ring-1 ring-accent-line ring-inset">
        <LogOut className="size-6" strokeWidth={1.75} />
        <Spinner label={null} className="absolute -right-1.5 -bottom-1.5 size-5 border-[2.5px] bg-background text-accent" />
      </span>
      <div className="flex flex-col gap-1.5">
        <h1 className="text-2xl font-semibold tracking-tight">
          <Trans>Saindo!</Trans>
        </h1>
        <p className="text-sm text-muted-foreground">
          <Trans>Limpando suas credenciais e redirecionando para o login. Aguarde</Trans>
        </p>
      </div>
    </div>
  );
}
